let FormControls = mc.widgets.FormControls;

class AnnotationForm extends React.Component {
  componentDidMount() {
    this.refs.input.focus();
  }

  keyUp(evt) {
    if (mc.ui.keyboard.isEscape(evt)) {
      this.props.onCancel();
    }
  }

  setValue(evt) {
    let annotation = this.props.annotation;
    annotation.value = evt.target.value;

    this.props.onEdit(annotation);
  }

  setBound(bound) {
    this.props.onEditBound(bound);
  }

  cancel(evt) {
    this.props.onCancel();

    evt.preventDefault();
  }

  saveAnnotation(evt) {
    let annotation = this.props.annotation;

    this.props.onSave(annotation, annotation.id ? "UPDATE" : "CREATE");

    evt.preventDefault();
  }

  deleteAnnotation(evt) {
    let annotation = this.props.annotation;

    this.props.onSave(annotation, "DELETE");

    evt.preventDefault();
  }

  render() {
    let { annotation, timezone, bound } = this.props;

    return (
      <form className="rc-annotation-form" onSubmit={this.saveAnnotation.bind(this)} onKeyUp={this.keyUp.bind(this)}>
        <div className="rc-annotation-form-cell">
          <input
            ref="input"
            type="text"
            placeholder={tx("label")}
            value={annotation.value}
            onChange={this.setValue.bind(this)}/>
        </div>
        <div className="rc-annotation-form-cell">
          <small>{tx("start")}</small>
          <input
            type="button"
            value={mc.format.time(annotation.startTs, timezone, "precise")}
            className="rc-annotation-form-ts"
            data-selected={bound === 0}
            onClick={this.setBound.bind(this, 0)}/>
        </div>
        <div className="rc-annotation-form-cell">
          <small>{tx("stop")}</small>
          <input
            type="button"
            value={mc.format.time(annotation.stopTs, timezone, "precise")}
            className="rc-annotation-form-ts"
            data-selected={bound === 1}
            onClick={this.setBound.bind(this, 1)}/>
        </div>
        <div className="rc-annotation-form-cell">
          <FormControls
            onCancel={this.cancel.bind(this)}
            onDelete={annotation.id && this.deleteAnnotation.bind(this)}
            enabled={annotation.value.trim().length > 0}/>
        </div>
      </form>
    );
  }
}

module.exports = AnnotationForm;
